import Pill from './Pill.wrapper';
import { IPill } from './Pill.interfaces';

export default Pill;
export { Pill, IPill };
